import React, { useEffect, useState } from 'react'

// next components

// images and icons
import SolanaLogoMobileIcon from 'assets/icons/solana-logo-gray-14x12.svg?component'

// styles
import styles from './index.module.scss'

import { calculateTimeLeft } from 'utils/helpers'

const AuctionCard = props => {
  const { currentPrice, reservePrice, endTime, startTime, setIsEnded, setIsStarted, liveAuction, isEditionListing } =
    props
  const [timeLeft, setTimeLeft] = useState(null)
  const [auctionStarted, setAuctionStarted] = useState(null)
  useEffect(() => {
    if (
      liveAuction &&
      !isEditionListing &&
      startTime !== undefined &&
      startTime !== null &&
      endTime !== undefined &&
      endTime !== null
    ) {
      setTimeLeft(calculateTimeLeft(getStartTime()))
      const timer = setInterval(() => {
        let time_left = calculateTimeLeft(getStartTime())
        setTimeLeft(time_left)
      }, 1000)

      return () => {
        clearTimeout(timer)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime])

  const getStartTime = () => {
    let startDate = new Date(startTime)
    let proposalStartTime = startDate.getTime()
    let difference = proposalStartTime - new Date().getTime()

    if (difference >= 0) {
      setAuctionStarted(false)
      return startTime
    } else {
      setIsStarted(true)
      setAuctionStarted(true)

      let endDate = new Date(endTime)
      let proposalEndTime = endDate.getTime()
      let end_difference = proposalEndTime - new Date().getTime()
      if (end_difference < 0) setIsEnded(true)
      return endTime
    }
  }

  const isExpired = time => {
    if (time['days'] === '00' && time['hours'] === '00' && time['minutes'] === '00' && time['seconds'] === '00')
      return true
    return false
  }

  return (
    <div className={styles.container}>
      <div className="w-full flex justify-between ">
        <div className="">
          <div className={styles.highestBid}>{currentPrice > 0 ? 'Highest Bid' : 'Reserve Price'}</div>
          <div className="flex gap-[6px] mt-[9px]">
            <div className="flex items-center">
              <SolanaLogoMobileIcon alt="" />
            </div>
            <div className={styles.whiteText}>
              {Math.round((currentPrice > 0 ? currentPrice : reservePrice) * 1000) / 1000}
            </div>
          </div>
        </div>
        {timeLeft && !isExpired(timeLeft) && !isEditionListing && (
          <div>
            <div className="flex justify-end">
              <div className={styles.highestBid}>{auctionStarted === true ? 'Time Remaining' : 'Starts In'}</div>
            </div>

            <div className={`${styles.bidCountContainer} pl-[12px] mt-[9px]`}>
              {timeLeft && timeLeft['days'] !== '00' && (
                <div>
                  <div className={styles.endTime}>
                    {timeLeft && timeLeft['days']}
                    {timeLeft && <div className={styles.bidDesc}>d</div>}
                  </div>
                </div>
              )}
              <div className={styles.endTimeContainer}>
                <div className={styles.endTime}>
                  {timeLeft && timeLeft['hours']}
                  {timeLeft && <div className={styles.bidDesc}>h</div>}
                </div>
              </div>
              <div className={styles.endTimeContainer}>
                <div className={styles.endTime}>
                  {timeLeft && timeLeft['minutes']}
                  {timeLeft && <div className={styles.bidDesc}>m</div>}
                </div>
              </div>
              <div className={styles.endTimeContainer}>
                <div className={styles.endTime}>
                  {timeLeft && timeLeft['seconds']}
                  {timeLeft && <div className={styles.bidDesc}>s</div>}
                </div>
              </div>
            </div>
          </div>
        )}

        {timeLeft && isExpired(timeLeft) && (
          <div>
            <div className="flex justify-end">
              <div className={styles.highestBid}>Time Remaining</div>
            </div>

            <div className={`${styles.bidCountContainer} pl-[12px] mt-[9px]`}>
              <div className={styles.endTime}>Auction Ended</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AuctionCard
